import { render, staticRenderFns } from "./SlottedTag.vue?vue&type=template&id=56df099b&scoped=true"
import script from "./SlottedTag.vue?vue&type=script&lang=js"
export * from "./SlottedTag.vue?vue&type=script&lang=js"
import style0 from "./SlottedTag.vue?vue&type=style&index=0&id=56df099b&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56df099b",
  null
  
)

export default component.exports